
require("./../../../node_modules/@module-federation/nextjs-mf/src/include-defaults.js");
import MainLayout from 'global/MainLayout';
import PageLoader from 'global/Loading/PageLoader';
import useProtectedRoute from 'hooks/useProtectedRoute';
import dynamic from 'next/dynamic';
import { useRouter } from 'next/router';

const Catalog = dynamic(() => import('features/catalog'), { ssr: false });

function CatalogPage() {
  const { isLoaded } = useProtectedRoute();
  const router = useRouter();

  const { slugs, sector } = router.query;

  // @ts-ignore
  const [subsector]: Array<string> = slugs || [undefined];

  return (
    <MainLayout>
      <PageLoader loaded={isLoaded} />
      <Catalog sector={sector} subsector={subsector} />
    </MainLayout>
  );
}

export default CatalogPage;
